import AsyncStorage from '@react-native-async-storage/async-storage';

import type { OnboardingDraft } from '../../types/onboarding';
import { createEmptyOnboardingDraft, normalizeOnboardingDraft } from '../../data/onboardingDefaults';
import { detectCountryFromLocale } from '../../utils/detectLocaleCountry';

const ONBOARDING_DRAFT_KEY = '@budget_onboarding_draft';

export async function getOnboardingDraft(): Promise<OnboardingDraft> {
  try {
    const raw = await AsyncStorage.getItem(ONBOARDING_DRAFT_KEY);
    if (!raw) {
      // First launch: preselect country + currency from device locale (no FX conversion).
      return createEmptyOnboardingDraft(detectCountryFromLocale());
    }
    return normalizeOnboardingDraft(JSON.parse(raw) as Partial<OnboardingDraft>);
  } catch {
    return createEmptyOnboardingDraft(detectCountryFromLocale());
  }
}

export async function setOnboardingDraft(draft: OnboardingDraft): Promise<void> {
  try {
    await AsyncStorage.setItem(ONBOARDING_DRAFT_KEY, JSON.stringify(draft));
  } catch {
    // Non-fatal — draft still lives in-session
  }
}
